var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4984 13.4985C13.4224 13.4985 13.3474 13.4812 13.2792 13.4479C13.2109 13.4146 13.1511 13.3662 13.1043 13.3063C12.3899 12.3916 11.7271 11.6857 10.8131 11.2125C9.96714 10.776 8.90464 10.5482 7.49839 10.5057V12.9985C7.49809 13.0961 7.46924 13.1915 7.41538 13.2728C7.36153 13.3542 7.28504 13.4181 7.19533 13.4565C7.10562 13.495 7.00663 13.5063 6.91055 13.4892C6.81447 13.472 6.72551 13.4271 6.65464 13.36L1.15464 8.11004C1.10577 8.06335 1.06686 8.00724 1.04028 7.9451C1.0137 7.88295 1 7.81607 1 7.74848C1 7.68089 1.0137 7.614 1.04028 7.55185C1.06686 7.48971 1.10577 7.4336 1.15464 7.38691L6.65464 2.13691C6.72551 2.06981 6.81447 2.02492 6.91055 2.00778C7.00663 1.99063 7.10562 2.00198 7.19533 2.04042C7.28504 2.07886 7.36153 2.14271 7.41538 2.22411C7.46924 2.3055 7.49809 2.40088 7.49839 2.49847V5.00973C9.81526 5.11629 11.5415 5.97566 12.6343 7.56816C13.5396 8.88723 13.9984 10.7141 13.9984 12.9985C13.9984 13.1311 13.9457 13.2583 13.8519 13.352C13.7582 13.4458 13.631 13.4985 13.4984 13.4985Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyIcon);
export default __webpack_public_path__ + "static/media/reply-icon.8c153a128285ae5cd749fc3d5ce76cea.svg";
export { ForwardRef as ReactComponent };